import(/* webpackMode: "eager", webpackExports: ["AppSidebar"] */ "/app/apps/admin/components/app-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnsureSidebarLink"] */ "/app/apps/admin/components/shell/ensure-sidebar-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracker"] */ "/app/apps/admin/components/shell/page-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/app/apps/admin/components/shell/user-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserPlanBadge"] */ "/app/apps/admin/components/shell/user-plan-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/apps/admin/providers/user-context-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@clerk/nextjs/dist/esm/app-router/client/ClerkProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@clerk/nextjs/dist/esm/app-router/client/keyless-cookie-sync.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticateWithRedirectCallback","ClerkDegraded","ClerkFailed","ClerkLoaded","ClerkLoading","RedirectToCreateOrganization","RedirectToOrganizationProfile","RedirectToSignIn","RedirectToSignUp","RedirectToTask","RedirectToUserProfile"] */ "/app/node_modules/@clerk/nextjs/dist/esm/client-boundary/controlComponents.js");
;
import(/* webpackMode: "eager", webpackExports: ["useAuth","useClerk","useEmailLink","useOrganization","useOrganizationList","useReverification","useSession","useSessionList","useSignIn","useSignUp","useUser"] */ "/app/node_modules/@clerk/nextjs/dist/esm/client-boundary/hooks.js");
;
import(/* webpackMode: "eager", webpackExports: ["PromisifiedAuthProvider"] */ "/app/node_modules/@clerk/nextjs/dist/esm/client-boundary/PromisifiedAuthProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["APIKeys","CreateOrganization","GoogleOneTap","OrganizationList","OrganizationProfile","OrganizationSwitcher","PricingTable","SignIn","SignInButton","SignInWithMetamaskButton","SignOutButton","SignUp","SignUpButton","TaskChooseOrganization","UserButton","UserProfile","Waitlist"] */ "/app/node_modules/@clerk/nextjs/dist/esm/client-boundary/uiComponents.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/cache/client-cache-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/config/client-config-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useLazyRemote"] */ "/app/packages/shared-hooks/src/hooks/fetch/use-lazy-remote.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRemote"] */ "/app/packages/shared-hooks/src/hooks/fetch/use-remote.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo_alt_centered_white.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo_alt_centered.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo_white.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/components/design-system/sidebar/sidebar.tsx");
